import { Backdrop, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';

const LoadingBackdrop = ({ open }) => {

    const [ isOpen, setIsOpen ] = useState(open)

    useEffect(() => {
        setIsOpen(open)
    }, [open])
    

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isOpen}
            onClick={() => setIsOpen(false)}
        >
            <CircularProgress />
        </Backdrop>
    );
};

export default LoadingBackdrop;
